export default function (app) {
  app
    .filter('klCurrency', [
      '$filter',
      'klAccountService',
      'klConfigService',
      function ($filter, AccountService, ConfigService) {
        function klCurrencyFilter(input) {
          return ConfigService.formatAmount(input, AccountService.getCurrency());
        }
        klCurrencyFilter.$stateful = true;
        return klCurrencyFilter;
      },
    ])
    .filter('klAmountStart', [
      '$filter',
      'klAccountService',
      'klConfigService',
      function ($filter, AccountService, ConfigService) {
        return function (input) {
          return parseInt(Math.floor(input));
        };
      },
    ])
    .filter('klAmountEnd', [
      '$filter',
      'klAccountService',
      'klConfigService',
      function ($filter, AccountService, ConfigService) {
        return function (input) {
          let cents = Math.round((parseFloat(input) - parseInt(Math.floor(input))) * 100);
          if (cents >= 10) return cents;
          return `0${cents}`;
        };
      },
    ]);
}
